<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        md="12"
      >
        <base-card>
          <div class="shadow-none">
            <div
              class="d-flex justify-space-between flex-wrap align-center"
            >
              <v-card-title>
                Ad assets
              </v-card-title>
              <div class="pa-2">
                <v-btn
                  :disabled="true"
                  color="primary"
                >
                  <i class="mdi mdi-plus p-r-5" />
                  upload
                </v-btn>
              </div>
            </div>
          </div>
          <v-card-text>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Ad
                    </th>
                    <th class="text-left">
                      Ad Duration
                    </th>
                    <th class="text-left">
                      HLS
                    </th>
                    <th class="text-left">
                      Serve On
                    </th>
                    <th>
                      Upcoming Impressions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="ad in ads"
                    :key="ad.id"
                    class="text--pointer"
                  >
                    <td
                      class="text-no-wrap font-weight-bold"
                    >
                      {{ ad.name }}
                      <v-btn
                        x-small
                        icon
                        class="m-l-5"
                        color="grey"
                        @click="editAd(ad)"
                      >
                        <v-icon size="18">
                          mdi-pencil
                        </v-icon>
                      </v-btn>
                    </td>
                    <td
                      class="text-no-wrap"
                    >
                      {{ ad.duration }} sec
                    </td>
                    <td>
                      <v-btn
                        class="mx-2 shadow-none orange darken-1"
                        fab
                        dark
                        x-small
                        @click.prevent="openPlayer(ad.stream_url, ad.name)"
                      >
                        <v-icon>mdi-play</v-icon>
                      </v-btn>
                    </td>
                    <td>
                      <h6>
                        <a
                          href="#"
                          class="text-decoration-underline"
                          @click.prevent="selectChannels(ad)"
                        >
                          {{ ad.assets.length }} channels
                        </a>
                      </h6>
                    </td>
                    <td>
                      {{ ad.impressions }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </base-card>
      </v-col>
    </v-row>
    <!-- Player -->
    <v-bottom-sheet
      v-model="playerDialog"
      max-width="960"
      inset
    >
      <v-card tile>
        <iframe
          id="serviceFrameSend"
          :src="frameSrc"
          width="100%"
          height="380"
          frameborder="0"
        />
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="p-l-20 p-r-20">
                {{ playerTitle }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-card-actions>
          <v-spacer />
          <v-btn
            depressed
            @click="closePlayer()"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-bottom-sheet>
    <!-- Select Channels Form  -->
    <v-dialog
      v-model="selectChannelDialog"
      max-width="1024px"
    >
      <v-card :loading="loading">
        <v-card-title class="pb-0">
          <span class="text-h5">Selected channels ({{ selectedChannels.length }})</span>
          <v-spacer />
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            class="pa-3"
            single-line
            hide-details
            clearable
          />
        </v-card-title>
        <v-card-subtitle>{{ selectedAd.name }} - {{ selectedAd.duration }} sec</v-card-subtitle>
        <v-card-text>
          <v-container>
            <v-data-table
              v-model="selectedChannels"
              :search="search"
              :headers="channelHeaders"
              show-select
              :items="channels"
              item-key="id"
              class="elevation-1 table-one pointer"
              multi-sort
              dense
              :items-per-page="15"
              :footer-props="{
                'items-per-page-options': [15, 30, 50],
                showFirstLastPage: true,
                firstIcon: 'mdi-arrow-collapse-left',
                lastIcon: 'mdi-arrow-collapse-right',
              }"
            >
              <template v-slot:item.name="{item}">
                <p class="ma-0 font-weight-medium">
                  {{ item.name }}
                </p>
              </template>
              <template v-slot:item.podDuration="{item}">
                <v-chip
                  color="primary"
                >
                  {{ item.podDuration}}
                </v-chip>
              </template>
              <template v-slot:item.genres="{item}">
                <v-chip
                  v-for="(genre, genreIndex) of item.genres.slice(0, 2)"
                  :key="genre.id"
                  color="yellow"
                  small
                  :class="{
                    'm-r-5': item.genres.length > 0 && genreIndex < item.genres.length - 1,
                  }"
                >
                  {{ genre.name }}
                </v-chip>
                <v-chip
                  v-if="item.genres.length > 2"
                  color="grey"
                  small
                >
                  +{{ item.genres.length - 2 }}
                </v-chip>
              </template>
              <template v-slot:item.instance="{item}">
                {{ item.instance | truncate(20) }}
              </template>
            </v-data-table>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            :disabled="loading"
            text
            @click="selectChannelDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            :disabled="loading"
            @click="setChannels()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Patch Name Form  -->
    <v-dialog
      v-model="patchDialog"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Update Ad Title</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="12"
              >
                <v-text-field
                  v-model="patched.name"
                  label="Name*"
                  :counter="255"
                  :rules="rules.nameRules"
                  required
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="patchDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            :disabled="loading || !isPatchFormValid"
            @click="updateAd()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    metaInfo: {
      title: 'Distribution Packages',
    },
    data () {
      return {
        ads: [],
        channels: [],
        channelMap: {},
        deleted: {},
        playerDialog: false,
        playerTitle: '',
        frameSrc: '',
        selectChannelDialog: false,
        selectedChannels: [],
        search: '',
        selectedAd: {},
        channelHeaders: [
          {
            text: 'Name',
            align: 'start',
            sortable: true,
            value: 'name',
          },
          { text: 'Pod dur (sec)', value: 'podDuration', sortable: true },
          { text: 'Genres', sortable: false, value: 'genres' },
          { text: 'Company', value: 'instance', sortable: true },
        ],
        patchDialog: false,
        patched: {
          id: 0,
          name: '',
        },
        rules: {
          nameRules: [
            v => !!v || 'Name is required',
            v => (v.length >= 3 && v.length <= 255) || 'Name must be between 3 and 255 characters',
          ],
        },
      }
    },
    computed: {
      loading () {
        return this.$store.getters.isDataLoaded
      },
      defaultIcon () {
        return '/images/no_logo.jpeg'
      },
      isPatchFormValid () {
        if (!(this.patched.name.length >= 3 && this.patched.name.length <= 255)) {
          return false
        }
        return true
      },
    },
    watch: {
      'playerDialog' (to, from) {
        if (to === false) {
          this.closePlayer()
        }
      },
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        this.$store.commit('setPageLoader')

        const adsArgs = {
          $expand: 'assets',
        }
        const adsReq = this.$store.dispatch('adItems', adsArgs)

        const channelArgs = {
          'suspended[eq]': 0,
          $expand: 'instance,genres,ads',
        }
        const channelReq = this.$store.dispatch('channels', channelArgs)

        const impressionsArgs = {}
        const impressionsReq = this.$store.dispatch('adItemsUpcomingImpressions', impressionsArgs)

        return Promise.all([adsReq, channelReq, impressionsReq, impressionsReq])
          .then((res) => {
            const channels = res[1] || []
            this.channels = []

            for (let i = 0; i < channels.length; i += 1) {
              const ch = channels[i]
              if (!ch.genres) {
                ch.genres = []
              }

              let podDur = 0
              if (ch.ads) {
                podDur = ch.ads.ad_block_duration || 0
              }

              const processedCh = {
                id: ch.id,
                name: ch.name,
                instance: ch.instance.name,
                genres: ch.genres,
                podDuration: podDur,
              }
              this.channels.push(processedCh)
              this.channelMap[ch.id] = processedCh
            }

            const impressions = res[2] || []
            const impMap = {}
            for (let i = 0; i < impressions.length; i += 1) {
              impMap[impressions[i].AdItemId] = impressions[i].Impressions
            }

            const ads = res[0] || []
            for (let i = 0; i < ads.length; i += 1) {
              if (!ads[i].assets) {
                ads[i].assets = []
              }
              ads[i].impressions = 0
              // eslint-disable-next-line no-prototype-builtins
              if (impMap.hasOwnProperty(ads[i].id)) {
                ads[i].impressions = impMap[ads[i].id]
              }
            }
            this.ads = ads
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
            this.$router.push({ name: 'ChannelsPage' })
          })
          .finally(() => this.$store.commit('resolvePageLoader'))
      },
      selectChannels (ad) {
        this.selectedAd = ad
        this.selectedChannels = []
        for (let i = 0; i < ad.assets.length; i += 1) {
          const asset = ad.assets[i]
          // eslint-disable-next-line no-prototype-builtins
          if (this.channelMap.hasOwnProperty(asset.channel_id)) {
            this.selectedChannels.push(this.channelMap[asset.channel_id])
          }
        }
        this.selectChannelDialog = true
      },
      setChannels () {
        this.$store.commit('setPageLoader')

        const ids = []
        for (let i = 0; i < this.selectedChannels.length; i += 1) {
          const id = this.selectedChannels[i].id
          ids.push(id)
        }

        const data = {
          id: this.selectedAd.id,
          ids: ids,
        }

        this.$store.dispatch('setAdToChannels', data)
          .then(() => {
            this.loadData()
            this.selectChannelDialog = false
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.$store.commit('resolvePageLoader')
          })
      },
      editAd (ad) {
        this.patched.id = ad.id
        this.patched.name = ad.name
        this.patchDialog = true
      },
      updateAd () {
        this.$store.commit('setPageLoader')

        const data = {
          id: this.patched.id,
          name: this.patched.name,
        }

        this.$store.dispatch('updateAdItem', data)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'The ad title has been successfully updated',
              timeout: 6000,
              color: 'success',
            })
            for (let i = 0; i < this.ads.length; i += 1) {
              if (this.ads[i].id === this.patched.id) {
                this.ads[i].name = this.patched.name
                break
              }
            }
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.patchDialog = false
            this.$store.commit('resolvePageLoader')
          })
      },
      openPlayer (url, title) {
        this.setFrameSrc(url)
        this.playerDialog = true
        this.playerTitle = title
      },
      setFrameSrc (url) {
        const link = url.replace(/^http:\/\//, 'https://')
        this.frameSrc = `/js/radiant/index2.html?src=${link}`
      },
      closePlayer () {
        this.playerDialog = false
        this.playerTitle = ''
        this.setFrameSrc('')
      },
    },
  }
</script>

<style>
</style>
